export const TIMELINE_MAX_TEXT_LENGTH = 100
